/**
 * Разбор полей ответа сервера на открытие квиза и пейволла — общий для обоих
 * обработчиков загрузки в `editorSlice.ts` (вынесено под храповик длины фасада
 * WEB-2552, карточка WEB-2971; поведение то же, что было в обработчиках).
 */
import type { Rule } from '@/logic-engine';

/**
 * WEB-384 data-loss: ручные правки правил автосохраняются в `draftLogic`, и
 * открытие обязано брать их раньше опубликованных `logic` (пара к
 * `draftContent ?? content`). Массив черновика — даже пустой — главнее; не
 * массив ни там, ни там — правил нет.
 */
export function loadedLogicOf(data: Record<string, unknown>): Rule[] {
  if (Array.isArray(data.draftLogic)) return data.draftLogic as Rule[];
  return Array.isArray(data.logic) ? (data.logic as Rule[]) : [];
}

/**
 * WEB-3001: `generationId` из ответа сервера на открытие квиза/пейволла.
 * Не строка (нет поля у старого сервера, null, чужой формат) — связи нет.
 */
export function generationIdOf(data: Record<string, unknown>): string | null {
  return typeof data.generationId === 'string' && data.generationId
    ? data.generationId
    : null;
}

/**
 * WEB-2230 (кабинетный заход 3): открытый ресурс ни разу не публиковался.
 *
 * Сервер переводит такой квиз или пейволл с ЧЕРНОВИКА
 * (`backend/src/translations/services/draft-translation-source.util.ts`,
 * `pickFullTranslationSource`: нет версии публикации и нет даты публикации),
 * и окно «Добавить перевод» обязано сказать об этом до заказа.
 *
 * Версий публикации кабинет при открытии не видит, поэтому судит по
 * жизненному циклу: «черновик» (DRAFT) бывает только до первой публикации —
 * снятие с публикации переводит в INACTIVE (WEB-416) и обнуляет дату
 * публикации, так что одной даты мало. Дата публикации при черновике
 * (старая запись) — «публиковался». Состояния нет в ответе — `false`:
 * про неизвестное не предупреждаем (граница — в отчёте WEB-2230).
 */
export function neverPublishedOf(data: Record<string, unknown>): boolean {
  const state = typeof data.state === 'string' ? data.state.toLowerCase() : '';
  return state === 'draft' && !data.publishedAt;
}
